import { Pane } from "react-leaflet";
import SitePlanPolygon from "./SitePlanPolygon";
import { useSitePlan } from "./UseSitePlan";
import { ZIndex } from "../../constants/zindex";

const SitePlan = () => {
  const { selectSitePlan, sitePlan, sitePlanSelected } = useSitePlan();
  return (
    <Pane name="site-plan" style={{ zIndex: ZIndex.sitePlan }}>
      {sitePlan && (
        <SitePlanPolygon
          key={`${sitePlan.id}-${sitePlanSelected}`}
          selectSitePlan={sitePlanSelected ? () => {} : () => selectSitePlan()}
          sitePlan={sitePlan}
          sitePlanSelected={sitePlanSelected}
        />
      )}
    </Pane>
  );
};

export default SitePlan;
